import {DateType, JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("SolicitacaoCancelamentoEscrituracaoTO")
export class SolicitacaoCancelamentoEscrituracaoTO {

  id: string;

  motivoDeferimento: string;

  dadosPrestador: string;

  dadosTomador: string;

  numeroSerie: string;

  valor: string;

  escritId: string;

  chaveAcesso: string;

  @DateType()
  dataPrestacao: Date;

  getFormatedEscritId(){
    return this.escritId.replace(/\+/g,"%2B");
  }
}
